import * as types from "../Action/type";

const initialState = {
    loading: false,
    error: null,
    FinnancedOrder: null,
    pricingOrder: null,
    trader: {},
    finnanced: null,
    factory: null,
    neworder: null
}




const socketReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_CLIENT_STATUS:
            console.log("Socket Reducer Client:", action.payload)
            return {
                ...state,
                clienstatus: action.payload.order,
            };
        case types.UPDATE_DRIVER_STATUS:
            console.log("Socket Reducer Driver:", action.payload)
            return {
                ...state,
                driverstatus: action.payload.order,
            };

        case types.UPDATE_NEW_ORDER:
            console.log("Socket Reducer new order:", action.payload)
            return {
                ...state,
                neworder: action.payload.order,
            };





        default:
            return state;
    }

}
export default socketReducer;